import { useTranslation } from 'react-i18next';
import { SetPasswordPage } from './SetPasswordPage';

// Reached from the "forgot password" email link: /account/resetPassword?email=&token=
export function ResetPasswordPage() {
    const { t } = useTranslation();
    return (
        <SetPasswordPage
            endpoint="login/ResetUserPassword"
            tokenParam="token"
            emailKey="Email"
            title={t('setPassword.resetTitle')}
            subtitle={t('setPassword.resetSubtitle')}
            submitLabel={t('setPassword.submitReset')}
        />
    );
}
